var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.4,
    height: 30.2,
    viewBox: "0 0 30.4 30.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_Titolo_Gruppi_di_Lavoro",
    "data-name": "icona Titolo Gruppi di Lavoro",
    transform: "translate(-1222.8 -761.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_911",
    "data-name": "Tracciato 911",
    d: "M15.056,168.675a7.871,7.871,0,0,1,6.666,7.5v5.6H1.235v-5.6a7.871,7.871,0,0,1,6.666-7.5,9.183,9.183,0,0,0,7.155,0m-.183-1.191a7.854,7.854,0,0,1-6.79,0A9.063,9.063,0,0,0,0,176.177v5.782a1,1,0,0,0,1.038.962H21.919a1,1,0,0,0,1.038-.962v-5.782a9.063,9.063,0,0,0-8.084-8.693Z",
    transform: "translate(1223 608.747)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_912",
    "data-name": "Tracciato 912",
    d: "M195.527,167.484a7.843,7.843,0,0,1-1.374.5,10.281,10.281,0,0,1,4.265,8.188v5.782a2.491,2.491,0,0,1-.2.962h4.35a1,1,0,0,0,1.038-.962v-5.782A9.063,9.063,0,0,0,195.527,167.484Z",
    transform: "translate(1049.389 608.747)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_914",
    "data-name": "Tracciato 914",
    d: "M2107.659,305h2.4l.694,9.535-1.875,1.486L2107,314.535Z",
    transform: "translate(-874.625 473.81)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_60",
    "data-name": "Ellisse 60",
    transform: "translate(1227.313 762.291)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.031,
    cy: 7.031,
    r: 7.031,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.031,
    cy: 7.031,
    r: 6.331,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sottrazione_2",
    "data-name": "Sottrazione 2",
    transform: "translate(1238.67 762.183) rotate(-3)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.812390089035034 13.56362247467041 C 2.27962589263916 13.56362247467041 1.756956815719604 13.50071430206299 1.24931526184082 13.37592601776123 C 3.388031005859375 12.00554466247559 4.718080043792725 9.625349044799805 4.718080043792725 7.03181266784668 C 4.718080043792725 4.438259601593018 3.388023138046265 2.058056116104126 1.249307513237 0.6876808404922485 C 1.756939888000488 0.5628976821899414 2.279584884643555 0.5000026822090149 2.812390089035034 0.5000026822090149 C 6.414040088653564 0.5000026822090149 9.344200134277344 3.430162668228149 9.344200134277344 7.03181266784668 C 9.344200134277344 10.63346290588379 6.414040088653564 13.56362247467041 2.812390089035034 13.56362247467041 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.812390089035034 13.06362247467041 C 6.138339996337891 13.06362247467041 8.844200134277344 10.35776233673096 8.844200134277344 7.03181266784668 C 8.844200134277344 3.705862760543823 6.138339996337891 1.00000262260437 2.812390089035034 1.00000262260437 C 2.708135843276978 1.00000262260437 2.604308128356934 1.00260865688324 2.500945091247559 1.007810831069946 C 4.199776649475098 2.507834434509277 5.218080043792725 4.687991142272949 5.218080043792725 7.03181266784668 C 5.218080043792725 9.375618934631348 4.199756622314453 11.55578422546387 2.500925064086914 13.05581188201904 C 2.604283094406128 13.06101417541504 2.70814323425293 13.06362247467041 2.812390089035034 13.06362247467041 M 2.812390089035034 14.06362247467041 C 1.834840059280396 14.06362247467041 0.8886200785636902 13.86673259735107 6.713867151120212e-08 13.47844219207764 C 2.562380075454712 12.35850238800049 4.218080043792725 9.829402923583984 4.218080043792725 7.03181266784668 C 4.218080043792725 4.235572814941406 2.562380075454712 1.705102682113647 6.713867151120212e-08 0.5851726531982422 C 0.8912400603294373 0.1957126706838608 1.837460041046143 2.667846729309531e-06 2.812390089035034 2.667846729309531e-06 C 6.689740180969238 2.667846729309531e-06 9.844200134277344 3.154462575912476 9.844200134277344 7.03181266784668 C 9.844200134277344 10.9091625213623 6.689740180969238 14.06362247467041 2.812390089035034 14.06362247467041 Z",
    stroke: "none",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupTitle);
export default __webpack_public_path__ + "static/media/group_title.dd557ec2ff15dcbed4b1d2117d0d479e.svg";
export { ForwardRef as ReactComponent };